// NIGHT-DIRECTSTAFF-2026-10-23 §4: lead -> candidate by phone as well as email. Phone-only leads now arrive from the
// phone-first flagship forms, and many candidates were made from an email (their record has no phone) -- so a phone-only
// lead used to join no one. A lead belongs to a candidate when, in this order:
//   'email'  its email is the candidate's (any case);
//   'phone'  its phone (last 10 digits, any format) is the candidate's own phone;
//   'lead'   its phone is the phone on one of the candidate's OWN leads (a lead with the candidate's email) -- the same
//            number the person gave us before, under their email.
// Ties (two candidates on one key) go to the lowest candidate id, so the answer never flickers.

const national = (v) => { const d = String(v || '').replace(/\D/g, ''); return d.length === 11 && d.startsWith('1') ? d.slice(1) : d.length >= 10 ? d.slice(-10) : ''; };
const emailKey = (v) => { const e = String(v || '').trim().toLowerCase(); return e.includes('@') ? e : ''; };

// NIGHT-DIRECTSTAFF-2026-10-23b §2: candidates merged into another (candidates.merged_into) are not in the lists, but their
// phone and email still find the person: a lead with them belongs to the candidate they were merged into. App sets them.
let mergedNow = [];
export function setMergedCandidates(list) { mergedNow = Array.isArray(list) ? list : []; }

/** The lookup tables for one set of candidates and leads. */
export function candidateIndex(candidates = [], leads = [], merged = mergedNow) {
  const byEmail = new Map(); const byPhone = new Map(); const byLeadPhone = new Map();
  const first = (m, k, c) => { if (k && (!m.has(k) || m.get(k).id > c.id)) m.set(k, c); };
  for (const c of candidates || []) { first(byEmail, emailKey(c.email), c); first(byPhone, national(c.phone), c); }
  const byId = new Map((candidates || []).map((c) => [String(c.id), c]));
  for (const m of merged || []) {             // an alias never takes a key a live candidate already holds
    const into = byId.get(String(m.merged_into));
    if (!into) continue;
    const e = emailKey(m.email); const p = national(m.phone);
    if (e && !byEmail.has(e)) byEmail.set(e, into);
    if (p && !byPhone.has(p)) byPhone.set(p, into);
  }
  for (const l of leads || []) {
    const c = byEmail.get(emailKey(l.email));
    if (c) first(byLeadPhone, national(l.phone), c);
  }
  return { byEmail, byPhone, byLeadPhone };
}

/** -> { candidate, via: 'email' | 'phone' | 'lead' } | null */
export function candidateMatch(lead, index) {
  if (!lead || !index) return null;
  const e = emailKey(lead.email);
  if (e && index.byEmail.has(e)) return { candidate: index.byEmail.get(e), via: 'email' };
  const p = national(lead.phone);
  if (p && index.byPhone.has(p)) return { candidate: index.byPhone.get(p), via: 'phone' };
  if (p && index.byLeadPhone.has(p)) return { candidate: index.byLeadPhone.get(p), via: 'lead' };
  return null;
}

// one index per (candidates, leads) pair: the lists call this once per row
let cache = { c: null, l: null, m: null, index: null };
export function cachedIndex(candidates, leads) {
  if (cache.c !== candidates || cache.l !== leads || cache.m !== mergedNow) cache = { c: candidates, l: leads, m: mergedNow, index: candidateIndex(candidates, leads) };
  return cache.index;
}

/** The words for how a lead was matched to its candidate. */
export const VIA_WORDS = { email: 'same email', phone: 'same phone', lead: 'same phone as their earlier lead' };
